/**
 * Icon set ported from the original prototype's `I` object. Each is a small
 * inline SVG so styling (size/color) is controlled by the parent via CSS.
 */
import type { SVGProps } from 'react';

type P = SVGProps<SVGSVGElement>;
const base = (props: P): P => ({
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  ...props,
});

export const CheckIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={3}>
    <path d="m5 13 4 4L19 7" />
  </svg>
);
export const PlusIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2.4}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);
export const ArrowIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2.2}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);
export const BackIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2.2}>
    <path d="M19 12H5M11 6l-6 6 6 6" />
  </svg>
);
export const DocIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
  </svg>
);
export const InfoIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2.2}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 16v-4M12 8h.01" />
  </svg>
);
export const SendIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2}>
    <path d="m22 2-7 20-4-9-9-4z" />
    <path d="M22 2 11 13" />
  </svg>
);
export const DollarIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2}>
    <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);
export const XIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2.2}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);
export const WarnIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2.2}>
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
    <path d="M12 9v4M12 17h.01" />
  </svg>
);
export const SearchIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2.2}>
    <circle cx="11" cy="11" r="7" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);
export const CopyIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2}>
    <rect x="9" y="9" width="13" height="13" rx="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);
export const SparkIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2}>
    <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" />
    <path d="M19 15l.7 1.9L21.6 17.6l-1.9.7L19 20l-.7-1.7-1.9-.7 1.9-.7z" />
  </svg>
);
export const DownloadIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <path d="M7 10l5 5 5-5" />
    <path d="M12 15V3" />
  </svg>
);
export const EyeIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
export const LoginIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2}>
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
    <path d="M10 17l5-5-5-5" />
    <path d="M15 12H3" />
  </svg>
);
export const LogoutIcon = (p: P) => (
  <svg {...base(p)} strokeWidth={2}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
  </svg>
);
